import classnames from "classnames";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import getEmailUsUrl from "@/utils/getEmailUsUrl";
import { MonetateContext } from "@/context/MonetateContext";
import { trackMonetateEvent } from "@/context/MonetateContext";
import { EmailOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/EmailOutlined";

import styles from "./contact-email.module.scss";

const unavailableEmailOption = () => (
  <div>
    <br />
    <p>
      <strong>Currently unavailable</strong>
    </p>
    <p>You can still get in touch by calling our Customer Service team.</p>
  </div>
);

const availableEmailOption = location => (
  <>
    <p>
      Please note: if you prefer to <Link href={getEmailUsUrl(location)}>email us</Link>, it may take up to 24 hours for
      a response and longer for us to resolve your query.
    </p>
    <p>We recommend phone for a quicker response and resolution.</p>
  </>
);

function ContactEmail({ className, config: { open }, location }) {
  const { liveChatProminenceExperiment } = useContext(MonetateContext);
  const router = useRouter();

  const handleEmailUsButtonClick = () => {
    trackMonetateEvent("email_contact_rate");
    router.push("/email-us?t=problemsWithProduct-problemsOther");
  };

  return (
    <>
      {liveChatProminenceExperiment ? (
        <div className={classnames(className, styles["contact-email"])} data-test="container-email">
          <h4 className={styles["contact-email-us__title"]}>Email us</h4>
          <p>Submit your photos using our email form.</p>
          <p>We’ll send you a case reference and a phone number.</p>
          <p>If it’s urgent, give us a call – otherwise we’ll reply within 24 hours.</p>
          <button
            type="button"
            className={classnames(styles["email-us-button"])}
            data-test="email-us-button"
            onClick={handleEmailUsButtonClick}
          >
            <span className={styles.emailIcon}>
              <EmailOutlined />
              Email us
            </span>
          </button>
        </div>
      ) : (
        <div className={classnames(className, styles["contact-email"])} data-test="container-email">
          <h4 className={styles["contact-email__title"]}>Email</h4>
          {open ? availableEmailOption(location) : unavailableEmailOption()}
        </div>
      )}
    </>
  );
}

ContactEmail.propTypes = {
  config: PropTypes.shape({
    open: PropTypes.bool,
  }).isRequired,
  className: PropTypes.string,
  location: PropTypes.string,
};

ContactEmail.defaultProps = {
  className: undefined,
  location: undefined,
};

export default ContactEmail;
